import React, { useState, useEffect } from 'react';
import { View, Text, TextInput, Modal } from 'react-native';
import { useUnistyles } from 'react-native-unistyles';
import { sanitizeFilename } from '@/utils/FileManager';
import SolidButton from '@/components/General/SolidButton';

const RenameModal = ({ visible, onClose, onRename, initialName }) => {
  const { theme: { colors } } = useUnistyles();
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (visible) {
      setName(initialName || '');
      setError('');
    }
  }, [visible, initialName]);

  const handleSubmit = () => {
    if (!name.trim()) {
      setError('Name is required');
      return;
    }

    const sanitized = sanitizeFilename(name);
    if (sanitized !== name) {
      setError('Name contains invalid characters');
      return;
    }

    onRename?.(sanitized);
  };

  return (
    <Modal visible={visible} transparent animationType="fade">
      <View style={{ flex: 1, backgroundColor: 'rgba(0,0,0,0.5)', justifyContent: 'center', alignItems: 'center', padding: 20 }}>
        <View style={{ backgroundColor: colors.card, borderRadius: 12, padding: 20, width: '100%', maxWidth: 400 }}>
          <Text style={{ color: colors.text, fontSize: 18, fontWeight: '600', marginBottom: 16 }}>
            Rename
          </Text>

          <TextInput
            placeholder="Name"
            value={name}
            onChangeText={setName}
            placeholderTextColor={colors.textSecondary}
            style={{
              backgroundColor: colors.background,
              borderRadius: 8,
              padding: 12,
              color: colors.text,
              fontSize: 14,
              borderWidth: 1,
              borderColor: error ? '#ef4444' : colors.border,
              marginBottom: error ? 4 : 16
            }}
            autoFocus
          />

          {error ? (
            <Text style={{ color: '#ef4444', fontSize: 12, marginBottom: 16 }}>{error}</Text>
          ) : null}

          <View style={{ flexDirection: 'row', gap: 12, justifyContent: 'flex-end' }}>
            <SolidButton text="Cancel" type="textSecondary" variant="outlined" onPress={onClose} />
            <SolidButton text="Save" onPress={handleSubmit} />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default RenameModal;
